module.exports = __webpack_public_path__ + "img/banner2.7825c1f6.png";